import { render, staticRenderFns } from "./berdomisili.vue?vue&type=template&id=89f666e4&"
import script from "./berdomisili.vue?vue&type=script&lang=js&"
export * from "./berdomisili.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports